export enum LogLevel {
  /**
     * NONE = 0: Logging will be disabled.
     */
  NONE = 0,
  /**
     * EMERGENCY = 1: Only emergencies will be logged.
     */
  EMERGENCY = 1,
  /**
     * ALERT = 2: Only alerts and above will be logged.
     */
  ALERT = 2,
  /**
     * CRITICAL = 3: Only critical and above will be logged.
     */
  CRITICAL = 3,
  /**
     * ERROR = 4: Only errors and above will be logged.
     */
  ERROR = 4,
  /**
     * WARNING = 5: Only warnings and above will be logged.
     */
  WARNING = 5,
  /**
     * NOTICE = 6: Only notices and above will be logged.
     */
  NOTICE = 6,
  /**
     * INFO = 7: Only info logs and above will be logged.
     */
  INFO = 7,
  /**
     * DEBUG = 8: Only debug logs and above will be logged.
     */
  DEBUG = 8,

  /**
     * ALL = 9: All logs will be logged.
     */
  ALL = 9,
}
